export interface LecturerCredentials {
  username: string;
  password: string;
}

export class LecturerAuthenticationError extends Error {
  constructor() {
    super('Invalid username or password. Please try again.');
    this.name = 'LecturerAuthenticationError';
  }
}

export function lecturerAuthorization(credentials: LecturerCredentials): string {
  return `Basic ${btoa(`${credentials.username}:${credentials.password}`)}`;
}

export async function authenticateLecturer(credentials: LecturerCredentials): Promise<void> {
  const response = await fetch('/sols/auth-check.txt', {
    headers: { Authorization: lecturerAuthorization(credentials), Accept: 'application/json' },
    credentials: 'omit',
    cache: 'no-store',
  });
  if (response.status === 401 || response.status === 403) throw new LecturerAuthenticationError();
  if (!response.ok || response.headers.get('X-Lecturer-User') !== credentials.username) {
    throw new Error('Lecturer authentication is not configured on this server.');
  }
  const result = await response.json();
  if (result?.authenticated !== true) throw new Error('Invalid authentication response.');
}
